import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ChurchFlowLogo from "@/components/ChurchFlowLogo";
import Footer from "@/components/Footer";

export default function LegalLayout({ title, eyebrow, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid={testid}>
      <header className="border-b border-border bg-card/60 backdrop-blur-md sticky top-0 z-10">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
            <ChurchFlowLogo size={36} className="rounded-xl" />
            <span className="font-serif text-xl tracking-tight">ChurchFlow</span>
          </Link>
          <Link
            to="/dashboard"
            className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to app
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <article className="max-w-[820px] mx-auto px-6 lg:px-10 py-14 fade-up">
          <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground">{eyebrow}</div>
          <h1 className="font-serif text-5xl tracking-tight mt-3">{title}</h1>
          {lastUpdated && (
            <p className="text-sm text-muted-foreground mt-3">Last updated: {lastUpdated}</p>
          )}
          <div className="rule-line mt-8" />

          <div className="prose-legal mt-8 space-y-6 text-foreground/85 leading-relaxed text-[15px]">
            {children}
          </div>

          <div className="mt-16 p-6 rounded-2xl bg-secondary/60 border border-border text-sm text-muted-foreground">
            Questions about this policy? Contact us at{" "}
            <a href="mailto:legal@ministrybranch.com" className="text-primary underline-offset-4 hover:underline">legal@ministrybranch.com</a>.
          </div>
        </article>
      </main>

      <Footer variant="auth" />

      <style>{`
        .prose-legal h2 {
          font-family: 'Bricolage Grotesque', 'Plus Jakarta Sans', sans-serif;
          font-size: 1.5rem;
          letter-spacing: -0.02em;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
          color: hsl(var(--foreground));
        }
        .prose-legal h3 {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 1.05rem;
          font-weight: 600;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
          color: hsl(var(--foreground));
        }
        .prose-legal p { margin-bottom: 0.75rem; }
        .prose-legal ul { list-style: disc; padding-left: 1.5rem; margin-bottom: 0.75rem; }
        .prose-legal ul li { margin-bottom: 0.4rem; }
        .prose-legal a { color: hsl(var(--primary)); text-underline-offset: 4px; }
        .prose-legal a:hover { text-decoration: underline; }
        .prose-legal strong { color: hsl(var(--foreground)); font-weight: 600; }
      `}</style>
    </div>
  );
}
